/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-03 15:42:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 19:16:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/LegalCategory/EditModal/tools.ts
 */
import { postGetLegalOptions, postCategoryLegal } from 'src/request/category';
import { dfsOptions } from 'src/pages/SalesChannelCategory/slice/tools';

const getOptions = async ({
  salesChannelUuid,
  selfUuid,
  requestId,
  setOptions,
}) => {
  const res = await postGetLegalOptions(
    {
      salesChannelUuid,
      salesChannelCategoryUuid: selfUuid || null,
    },
    { requestSourceID: requestId },
  );
  const options = dfsOptions(res, []);
  setOptions(options);
};

const submitChange = ({
  selfUuid,
  salesChannelUuid,
  urlSlug,
  parentUuid,
  onOk,
  requestId,
  name,
}) => {
  postCategoryLegal(
    {
      uuid: selfUuid,
      salesChannelUuid,
      urlSlug,
      name,
      parentUuid,
      root: !!!parentUuid,
    },
    { requestSourceID: requestId },
  ).then((res) => {
    if (onOk) onOk(res);
  });
};

export { getOptions, submitChange };
